import React from "react"
import { useSelector } from "react-redux"

const SessionTimeOut = () => {
  const isSessionTimeOut = useSelector(
    (state: {
      SessionTimeOut: {
        timeOut: boolean
      }
    }) => state.SessionTimeOut.timeOut
  )

  return (
    <>
      {isSessionTimeOut && (
        <div className="session-time-out">
          <div className="session-time-out-panel">
            <div className="session-time-out-text-area">
              <div className="brand-lockup" />
              <div className="session-time-out-text">
                セッションが切れましたので、再ログインをお願いします。
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default SessionTimeOut
